<template>

<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
   <template v-slot:activator="{ on }">
    <v-btn dark color="primary" v-on="on" class="mr-2">
        <v-icon v-text="buttonIcon" class="mr-2"></v-icon>
        Add
    </v-btn>
  </template>
  <v-card>

    <v-toolbar dark color="primary">
      <v-btn icon dark @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items>
        <v-btn dark text @click="dialog = false">Save</v-btn>
      </v-toolbar-items> -->
    </v-toolbar>

    <v-container fluid fill-height>
      <v-row dense>
        <v-col>
          <v-form ref="form" v-model="valid" class="mx-5 px-5">
          <v-text-field clearable v-model="searchInput" :rules="searchRules">
              <template v-slot:label>
                Search
              </template>
            </v-text-field>
          </v-form>
        </v-col>
      </v-row>
      <v-row dense v-if="notFound">
        <v-col>
           <v-form class="mx-5 px-5">
            <h4 v-text="message"></h4>
            <v-btn color="green" dark large @click="onAddNewBeerClick()" class="mx-2">
                Yes
            </v-btn>
            <v-btn color="error" large @click="dialog = false" class="mx-2">
                No
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-container fluid fill-height>
            <template v-for="beer in beers">
               <Beer v-bind="beer" :key="beer.beerId" collectionType="none" @open="onBeerClick(arguments[0])"/>
            </template>
          </v-container>
        </v-col>
      </v-row>
      <v-footer absolute>
        <div v-show="busy == false" ref="Bottom"><h4>...</h4></div>
      </v-footer>
    </v-container>
  </v-card>
</v-dialog>

</template>

<script>
import Beer from '@/components/Beer.vue';

const observerOptions = {
  root: null,
  threshold: 0,
};

export default {
  name: 'BeerSearch',
  components: {
    Beer,
  },
  props: {
    buttonIcon: {
      type: String,
      default: 'mdi-plus',
    },
    title: {
      type: String,
      default: 'Search',
    },
    collectionId: Number,
  },
  data: () => ({
    dialog: false,
    searchInput: '',
    searchRules: [
      (v) => (v && v.length >= 3) || (!v) || 'Minimum 3 chars',
    ],
    beers: [],
    valid: true,
    busy: true,
    page: 0,
    pages: 0,
    debounce: null,
    message: '',
    notFound: false,
  }),
  beforeMount() {
  },
  methods: {
    onBeerClick(beerId) {
      this.dialog = false;
      this.searchInput = '';
      this.$emit('open', beerId);
    },
    onAddNewBeerClick() {
      this.$router.push({ name: 'BeerAdd', params: { collectionId: this.collectionId, newName: this.searchInput } });
    },
  },
  computed: {
  },
  watch: {
    searchInput(val, oldVal) {
      if (this.dialog) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          if (this.valid) {
            this.page = 0;
            const data = {
              search: val,
            };

            this.busy = true;

            this.$webConn.request('app2_get_beers', data).then((result) => {
              this.pages = result.pages;
              this.beers = result.Beers;
              this.busy = false;
              if (!result.Beers.length) {
                this.notFound = true;
                this.message = 'Sorry, we don\'t seem to know that one yet, do you want to add it?';
              } else {
                this.notFound = false;
                this.message = '';
              }
            }).catch((error) => {
              alert(error.Message);
            });
          }
        }, 500);
      }
    },
  },
};
</script>
